<template>
  <div>
    <v-dialog
      :value="showDialog"
      persistent
      max-width="50%"
    >
      <v-card>
        <v-card-title class="headline">
          {{ isEdit?'Row edition':'Row creation' }}
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-row>
              <v-col
                v-if="dialogWarning"
                class="text-center"
                cols="12"
              >
                <div class="warning--text">
                  <v-icon
                    x-large
                    color="warning"
                  >
                    warning
                  </v-icon><v-spacer />
                  <span style="white-space: pre-line">{{ dialogWarning }}</span>
                </div>
              </v-col>
              <v-col
                v-for="(column, index) in columns"
                :key="index"
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model.lazy="editedRow[column['name']]"
                  v-validate="{rules: {numeric: column['type'] === 'int'}}"
                  :disabled="isEdit?column.primary_key:(column.generated&&column.primary_key)"
                  :data-vv-name="column['name']"
                  data-vv-scope="dialogEdit"
                  :placeholder="(column.primary_key && column.generated)?'Generated automatically':''"
                  :error-messages="errors.first('dialogEdit' + '.' +column['name'])"
                >
                  <template slot="label">
                    {{ column['name'] }} <span v-if="column.primary_key">&nbsp;<v-icon small>mdi-key</v-icon></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="handleCancel">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="handleSubmit"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showConfirmDialog"
      max-width="400px"
    >
      <v-card>
        <v-card-title class="headline">
          Edit ⚠️
        </v-card-title>
        <hr>
        <v-card-text>
          You are about to <b>edit</b> a row.<br>This step is <b>irreversible</b>.<br>
          Are you sure you want to continue ?
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            @click="showConfirmDialog=false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="warning"
            @click="handleApply"
          >
            Apply Edition
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import DatasetService from './../../../components/Dashboard/Views/Datastore/services/DatasetService'
  export default {
    props: {
      columns: {
        type: Array,
        required: true,
      },
      row: {
        type: Object,
        required: true,
      },
      datasetId: {
        type: String,
        required: true,
      },
      isEdit: {
        type: Boolean,
        default: true,
        required: false,
      },
      showDialog: {
        type: Boolean,
        default: false,
        required: false,
      },
    },
    data () {
      return {
        dialogWarning: '',
        showConfirmDialog: false,
        editedRow: {},
        dataset: {},
      }
    },
    watch: {
      row (vnew, vold) {
        if (!this.isEdit) {
          return
        }
        this.editedRow = _.cloneDeep(vnew)
        const me = this
        this.$nextTick(() => {
          me.$validator.validateAll('dialogEdit')
        })
      },
    },
    mounted () {
      const me = this
      this.dataset.hmd_id = this.datasetId
      if (!me.isEdit) { _.map(me.columns, (c, i) => { me.editedRow[c.name] = null }) }
      this.$nextTick(() => {
        me.$validator.validateAll('dialogEdit')
      })
    },
    methods: {
      handleCancel () {
        const me = this
        if (!me.isEdit) {
          _.map(me.columns, (c, i) => { me.editedRow[c.name] = null })
          me.close()
        } else {
          me.editedRow = {}
        }
        me.close()
      },
      clear () {
        this.editedRow = {}
      },
      close () {
        this.showConfirmDialog = false
        this.$emit('close')
      },
      handleSubmit () {
        const me = this
        if (_.isEqual(this.editedRow, this.row && me.isEdit)) {
          this.$store.commit('push', { msg: 'Please consider editing before submitting.', color: 'warning' })
          return
        }
        this.$validator.validateAll('dialogEdit').then(valid => {
          if (!valid) {
            me.$store.commit('push', { msg: 'Please consider validating your form before submitting.', color: 'warning' })
          } else {
            if (me.isEdit) { this.showConfirmDialog = true } else {
              const SubmitRow = _.cloneDeep(me.editedRow)
              if (this.columns.primary_key) {
                if (this.columns.primary_key.generated) { delete SubmitRow.primary_key }
              }
              DatasetService.insertRow(me, this.dataset, SubmitRow).then(r => {
                me.close()
                me.$emit('applyCreation', me.editedRow)
                _.delay(() => {
                  me.clear()
                }, 500)
              })
            }
          }
        })
      },
      handleApply () {
        var me = this
        DatasetService.updateRow(me, this.dataset, me.editedRow, me.columns).then(r => {
          me.$emit('applyEdition', me.editedRow)
          me.close()
          _.delay(() => {
            me.clear()
          }, 500)
        })
      },
    },

  }
</script>
